import React, { useState } from "react";

import { TooltipProps } from "antd";

import { trackMixpanel } from "utils";

import { Button, Icon, TooltipWrapper } from "components";

type SizeOptions = "large" | "middle" | "small";
type ShapeOptions = "circle" | "square";
type TypeOptions = "primary" | "secondary" | "tertiary";

interface IconButtonProps {
  className?: string;
  dataTestId?: string;
  iconName: string;
  size?: SizeOptions;
  shape?: ShapeOptions;
  type?: TypeOptions;
  disabled?: boolean;
  mixpanelText?: string;
  tooltip?: TooltipProps;
  onClick?: (e: React.MouseEvent) => void;
  loading?: boolean;
}

export const IconButton = ({ loading, className, dataTestId, type, shape, iconName, disabled, size, onClick, mixpanelText, tooltip }: IconButtonProps) => {
  // This is used to solve the issue of tooltips remaining open after the button click
  const [tooltipIsForcedClosed, setTooltipIsForcedClosed] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    trackMixpanel("ClickButton", {
      buttonText: mixpanelText || "undefined",
    });
    onClick?.(e);
    setTooltipIsForcedClosed(true);
  };

  return (
    <TooltipWrapper tooltip={tooltip} open={tooltipIsForcedClosed ? false : undefined}>
      <Button
        dataTestId={dataTestId}
        type={type}
        className={`icon-button ${shape ?? ""} ${className ?? ""}`}
        disabled={disabled}
        size={size}
        onClick={handleClick}
        loading={loading}
      >
        {!loading ? <Icon iconName={iconName} size="l" /> : null}
      </Button>
    </TooltipWrapper>
  );
};
